import * as yup from 'yup';

export const dentalHistoryValidationSchema = yup.object({
  user_id: yup.number().optional(),

  last_dental_visit: yup
    .string()
    .required('Last dental visit is required')
    .transform((value, originalValue) => (originalValue?.trim() === '' ? undefined : value))
    .test('valid-or-dontknow', 'Please enter a valid date or select "Not sure"', (value) => {
      if (!value) return false;
      if (value === 'dontKnow') return true;

      const date = new Date(value);
      return !isNaN(date.getTime());
    })
    .test('not-in-future', "You can't enter a future date", (value) => {
      if (!value || value === 'dontKnow') return true;

      const enteredDate = new Date(value);
      const now = new Date();
      return enteredDate <= now;
    }),

  who_did_you_see: yup
    .string()
    .required('Dentist seen is required')
    .transform((value, originalValue) => (originalValue?.trim() === '' ? undefined : value))
    .test('valid-or-dontknow', 'Please enter a dentist name or select "Not sure"', (value) => {
      if (!value) return false;
      if (value === 'dontKnow') return true;
      return value.trim().length > 0;
    })
    .max(100, 'Dentist name is too long'),

  visit_type: yup.string().optional(),
});
